import Rails from "@rails/ujs";

if (!window._rails_loaded) {
  Rails.start();
}

import '../../assets/stylesheets/application_admin.scss';
import Turbolinks from "turbolinks";
Turbolinks.start();
import "@rails/activestorage";
import "@fortawesome/fontawesome-free/js/all";
// Sprocketsから移行
import $ from 'jquery';
import 'bootstrap';
import 'popper.js';
import Vue from 'vue/dist/vue.esm'
// ライブラリ系
import '../../assets/javascripts/sidebar.js';
import '../../assets/javascripts/modernizr.custom.js';
import '../../assets/javascripts/swfobject.js';
import '../../assets/javascripts/jquery.js';
import '../../assets/javascripts/jquery.colorbox.js';
import '../../assets/javascripts/jquery.colorbox-min.js';
import '../../assets/javascripts/jquery_notification_v.1.js';

window.$ = $;
window.jQuery = $;

const components = import.meta.glob('../modules/**/*.js');

// Turbolinks がロードされたときにイベントリスナーを設定
document.addEventListener('turbolinks:load', () => {
  // `data-vue` 属性を持つすべての DOM 要素を取得
  const templates = document.querySelectorAll('[data-vue]');

  // 各 `data-vue` 要素に対してループを実行
  templates.forEach(el => {
    // `data-vue` 属性の値を取得し、コンポーネント名として使用
    const componentName = el.dataset.vue;

    // `components` 内のすべてのファイルパスを調べ、コンポーネント名に一致するファイルを見つける
    for (const path in components) {
      // ファイルパスがコンポーネント名で終わっているか確認
      if (path.endsWith(`${componentName}.js`)) {
        // 一致するコンポーネントを動的にインポートし、Vue インスタンスを生成してマウント
        components[path]().then(module => {
          new Vue(Object.assign(module.default, { el }));  // Vue インスタンスを作成し、要素にマウント
        });
        break;  // コンポーネントが見つかったらループを終了
      }
    }
  });
});
